import { Doctor } from "@/interfaces/Doctor";
import { Patient } from "@/interfaces/Patient";
import { Consultation } from "@/interfaces/Consultation";

export function convertToDoctor(data: any): Doctor {
  const safePhone = data.phoneNo?.startsWith("inactive-")
    ? data.phoneNo.replace("inactive-", "")
    : data.phoneNo;
  const safeEmail = data.email?.startsWith("inactive-")
    ? data.email.replace("inactive-", "")
    : data.email;
  return {
    id: data.id,
    email: safeEmail,
    firstName: data.firstName,
    lastName: data.lastName,
    title: data.title,
    photoUrl: data.photoUrl || "",
    phoneNo: safePhone,
    deviceType: data.deviceType?.toUpperCase(),
    confirmed: data.confirmed,
    status: data.status,
    specialization: data.specialty,
    docSet: data.docSet,
    requestId: data.requestId,
    createdAt: data.createdAt,
    patientsCount: data.patientsCount,
  };
}

export function convertDoctor(data: Doctor) {
  const safePhone =
    !data.phoneNo?.startsWith("inactive-") && data.status == 0
      ? "inactive-" + data.phoneNo
      : data.phoneNo;
  const safeEmail =
    !data.email?.startsWith("inactive-") && data.status == 0
      ? "inactive-" + data.email
      : data.email;
  return {
    id: data.id,
    email: safeEmail,
    firstName: data.firstName,
    lastName: data.lastName,
    title: data.title,
    photoUrl: data.photoUrl,
    phoneNo: safePhone,
    deviceType: data.deviceType,
    confirmed: data.confirmed,
    status: data.status,
    specialty: data.specialization,
    docSet: data.docSet,
    requestId: data.requestId,
  };
}

export function convertToPatient(data: any): Patient {
  const safePhone = data.phoneNo?.startsWith("inactive-")
    ? data.phoneNo.replace("inactive-", "")
    : data.phoneNo;
  const safeEmail = data.email?.startsWith("inactive-")
    ? data.email.replace("inactive-", "")
    : data.email;
  return {
    id: data.id,
    email: safeEmail,
    firstName: data.firstName,
    lastName: data.lastName,
    diagnose: data.diagnose,
    photoUrl: data.photoUrl || "",
    phoneNo: safePhone,
    deviceType: data.deviceType?.toUpperCase(),
    confirmed: data.confirmed,
    status: data.status,
    createdAt: data.createdAt,
    consultationCount: data.consultationCount,
  };
}

export function convertToConsultation(data: any): Consultation {
  return {
    id: data.id,
    bookingDate: data["booking-date"],
    bookingHour: data["booking-hour"],
    characterLimit: data["character-limit"],
    createdTimestamp: data["created-timestamp"],
    lastMessage: data["last-message"],
    startDate: data["startDate"],
    endDate: data["endDate"],
    owner: data.owner,
    ownerName: data.ownerName?.trim() || "",
    participants: data.participants || [],
    status: data.status,
    value: data.value,
    invoiceUrl: data.invoiceUrl,
    remainingCharacters: (0 + data["character-limit"] + data["additional-characters"]),
    initialCharacters: (0 + data["initial-characters"] + data["initial-additional-characters"]),
    usedCharacters: ((0 + data["initial-characters"] + data["initial-additional-characters"]) - (0 + data["character-limit"] + data["additional-characters"])),
  };
}
